import React from 'react';
import Helmet from 'react-helmet';
import './Collaborations.module.scss';

const imgCCC = require('assets/img/CCC.jpg');
const imgMocaCares = require('assets/img/moca-cares.png');

export default function GoogleForm() {
  return (
    <div className="main-section" style={{ margin: '2% 0'}}>
      <div className="page-section">
        <div className="container">
          <Helmet>
            <title>Moulmein-Cairnhill</title>
          </Helmet>
        </div>
      </div>
      <div className="page-section">
        <div className="container center">
          <div className="row">
            <div className="section-fullwidtht col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div>
                <img src={imgCCC} width="80" alt="CCC" />
                &nbsp;<b>Moulmein-Cairnhill 1-1 Zoom Tutoring</b>&nbsp;
                <img src={imgMocaCares} width="80" alt="Moca Cares" />
              </div>
              <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfm00nrbYDdV8eQ0otiuy-U3KydSHZHsFhBYHEw9ia1fZZPJQ/viewform?embedded=true" 
              width="640" height="1348" frameborder="0" marginheight="0" marginwidth="0" title="CCC Register">
                Loading…
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}